<template>
  <div class="home">
    <div v-if="status === 1">
      <el-row>
        <el-col :span="10"><h3>会议室预定</h3></el-col>
        <el-col :span="2"><h3>|</h3></el-col>
        <el-col :span="10" class="deletes"><h3 @click="todelete">删除预订</h3></el-col>
      </el-row>
      <el-row>
        <el-col :span="24">日期选择：</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-date-picker
            v-model="dates"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @blur="changedates">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row>
        <h5>会议室列表：<span class="reds">（红色为已预订）</span></h5>
      </el-row>
      <el-row v-for="item in initconferencedata" :key="item.id" class="office">
        <el-col :span="12">会议室名称： {{item.name}}</el-col>
        <el-col :span="12">可容纳人数： {{item.population}}</el-col>
        <el-col :span="12">位置： {{item.location}}</el-col>
        <el-col :span="12">描述： {{item.description}}</el-col>
        <el-col :span="24">时间段：</el-col>
        <el-col :span="6" v-for="times in item.booking_time" :key="times.index" :class="times.enabled ? '' : 'reds'" class="name-list"> {{times.value}} <br> <span class="name-bookers">{{times.bookers}}</span> </el-col>
        <el-col :span="24"><el-button type="primary" @click="startbook(item)">开始预订</el-button></el-col>
      </el-row>
    </div>
    <div v-else-if="status === 2">
      <el-row>
        <el-col :span="12" class="title">会议室名称： {{currentinitconference.name}}</el-col>
        <el-col :span="12" class="title">预订日期： {{dates}}</el-col>
        <el-col :span="24">会议主题：</el-col>
        <el-col :span="24">
          <el-input v-model="theme" placeholder="请输入内容"></el-input>
        </el-col>
        <el-col :span="24">时间段：</el-col>
      </el-row>
      <el-row>
        <el-col :span="6" v-for="item in currentinitconference.booking_time" :key="item.index">
          <el-button @click="judgeadd(item.index)" :disabled="!item.enabled" :class=" item.ischoose ? 'choose' : '' ">{{item.value}}</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="meeting-staff">会议人员：</el-col>
        <el-col :span="24">
          <el-cascader
            ref="cascaderAddr"
            :multiple="true"
            :options="options"
            :props="props"
            :show-all-levels="false"
            @change="add">
          </el-cascader>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-button type="primary" @click="backto">返回</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="submits">提交</el-button>
        </el-col>
      </el-row>
    </div>
    <div v-else-if="status === 3">
      <h3>个人预定列表</h3>
      <div v-for="item in reservelog" :key="item.id" class="self-reserve">
        <el-col :span="12">
          预定的会议室： {{item.meeting_room}}
        </el-col>
        <el-col :span="12">
          预定时间：{{item.booking_date}} {{item.booking_time}}
        </el-col>
         <el-col :span="24">
          会议主题：{{item.theme}}
        </el-col>
        <el-col :span="24">
          参会人员：
        </el-col>
        <el-col :span="6" v-for="(par, index) in item.participant_name" :key="index" >
          {{par}}
        </el-col>
        <el-col :span="24" class="delete-button">
          <el-button type="danger" @click="deteles(item.id)" size="small">删除</el-button>
        </el-col>
      </div>
      <el-col :span="24">
        <el-button type="primary" @click="backto">返回预定页面</el-button>
      </el-col>
    </div>
  </div>
</template>

<script>
const qs = require('qs')
var that = this
import storage from 'good-storage'
import Vue from 'vue'
import { conferencelist, submitnew, getuserreserve, deleteuserreserve, departmentlist, departmentmember, getuseid } from '../api/index'
export default {
  name: 'Index',
  data() {
    var that= this
    return {
      status: 1,
      bookersL: '',
      dates: '',
      time: [],
      form: {},
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time)
        }
      },
      initconferencedata: [],
      currentinitconference: {},
      choosevalue: {},
      reservelog: [],
      theme: '',
      props: { multiple: true, label: 'name', value: 'userid',lazy: true,
        async lazyLoad (node, resolve) {
          const { level } = node
          if (level === 1) {
            // console.log(node)
            const list = await departmentmember(node.data.userid)
            
            list.data.user_list.forEach((ele) => {
              ele.leaf = level >= 1
            })
            console.log(list.data.user_list)
            resolve(list.data.user_list)
          } else {
            resolve(node)
          }
        }
      },
      options: []
    } 
  },
  mounted() {
    console.log(storage.get('bookersL', 'uft'))
    if(storage.get('bookersL', 'uft') === 'uft'){
      let urls = window.location.href
      let parseUrl = qs.parse(urls.split('?')[1])
      this.getuser(parseUrl.code)
    } else {
      this.bookersL = storage.get('bookersL', 'uft')
    }
    this.dates = this.initdate()  //初始话当前日期
    this.initconference()
  },
  methods: {
    // 单独处理时间的函数
    dealDisabledDate (time) {
      return time.getTime() < Date.now() - 8.64e7
    },
    initdate: function() { // 获取当前日期
      let date = new Date()
      let seperator1 = "-"
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate
    },
    judgeadd: function(num) { // 选择
      const that = this
      if (this.time.length === 0) { // 判断是否为第一个 是就直接加进数组
        this.time.push(num)
        that.currentinitconference.booking_time[num].ischoose = true
        Vue.set(that.currentinitconference.booking_time, num, that.currentinitconference.booking_time[num])
        return false
      }
      else {
        const lastnum = this.time[this.time.length - 1]
        const fristnum = this.time[0]
        for(let i = 0; i < this.time.length; i ++) { // 循环判断是否有此值
          if (this.time[i] === num) { 
            if (num === lastnum ) {
              that.time.pop()
              that.currentinitconference.booking_time[num].ischoose = false
              Vue.set(that.currentinitconference.booking_time, num, that.currentinitconference.booking_time[num])
            } else if (num === this.time[0]) {
              that.currentinitconference.booking_time[num].ischoose = false
              Vue.set(that.currentinitconference.booking_time, num, that.currentinitconference.booking_time[num])
              that.time.shift()
            } else {
              this.$message.error('不能从连续时间段中开始删除')
            }
            console.log(this.time)
            return false
          }
        }
        let value = num - lastnum
        let value2 = num - fristnum
        if (value === 1) {
          this.time.push(num)
          that.currentinitconference.booking_time[num].ischoose = true
          Vue.set(that.currentinitconference.booking_time, num, that.currentinitconference.booking_time[num])
        } else if (value2 === -1) {
          this.time.unshift(num)
          that.currentinitconference.booking_time[num].ischoose = true
          Vue.set(that.currentinitconference.booking_time, num, that.currentinitconference.booking_time[num])
        }
        else {
          this.$message.error('只能连续选择时间段')
        }
        console.log(this.time)
        return false
      }
    },
    changedates: function() { //修改日期后更新会议室列表
      this.initconference()
    },
    async initconference() { //获取会议室列表
      let getData = await conferencelist(this.dates, '')
      console.log(getData.data)
      this.initconferencedata = getData.data
      // this.startbook(this.initconferencedata[0]) // 测试。。。。。。开发
    },
    startbook: function(item) {
      const that = this
      const datas = item
      datas.booking_time.forEach(function(currentValue, index, array) {
        datas.booking_time[index].ischoose = false
      })
      this.currentinitconference = datas
      this.status = 2
      this.departmentlists()
      console.log(this.currentinitconference)
    },
    async submits () { // 提交预订
      console.log(this.choosevalue)
      let newchoosevalue= ''
      this.choosevalue.forEach((ele, index)=> {
        if (index === 0 ) {
          newchoosevalue = ele[1]
        } else {
          newchoosevalue = newchoosevalue + '|' + ele[1] 
        }
      })
      const param = {
        meeting_room: this.currentinitconference.name,
        bookers: this.bookersL,
        participant: newchoosevalue,
        booking_time: this.time.join(),
        booking_date: this.dates,
        theme: this.theme
      }
      console.log(param)
      for(var key in param) {
        if(param[key] === '' || param[key] === undefined || param[key] === null) {
          console.log(key)
          this.$message.error(`预定失败,${key}的值为${param[key]}`)
          return false
        }
      }
      const getData = await submitnew(param)
      if (getData.data.status === 200) {
        this.$message({
          message: '预定成功！',
          type: 'success'
        })
        this.theme = ''
        this.todelete()
      } else {
        this.$message.error('预定失败')
      }
    },
    async getuserreserves() { // 当前用户详细预订记录
      const reserve = await getuserreserve(this.bookersL)
      console.log(reserve.data.result)
      this.reservelog = reserve.data.result
    },
    todelete () {
      this.getuserreserves()
      this.status = 3
    },
    async deteles(id) {
      const detelessubmit = await deleteuserreserve(id)
      console.log(detelessubmit.data.status)
      if (detelessubmit.data.status === 200) {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        this.getuserreserves()
      } else [
        this.$message.error('删除失败')
      ]
    },
    async departmentlists () { //部门列表
      const list = await departmentlist()
      console.log(list.data.department)
      this.options = list.data.department
      // console.log(this.options)
    },
    backto () {
      this.choosevalue = {}
      this.time = []
      this.initconference() //返回拉去信息
      this.theme = ''
      this.status = 1
    },
    add(value) {
      this.choosevalue = value
    },
    async getuser(id) {
      const user = await getuseid(id)
      console.log(user)
      if (user.data.status === 200) {
        this.bookersL = user.data.user_id
        storage.set('bookersL', this.bookersL)
      }
    }
  }
}
</script>

<style scoped>
.office{
  margin-top: 40px;
  margin-bottom:50px;
  padding-bottom: 20px;
  border-bottom: 1px solid #cccccc;
}
.is-selected {
  color: #1989FA;
}
.el-col-24,.el-col-12{
  text-align: left;
  margin-bottom: 20px;
}
.el-col-4{
  text-align: left;
  margin-bottom: 20px;
}
.el-col-6{
  text-align: left;
  margin-bottom: 20px;
}
.reds{
  color: red;
}
.choose{
  background: #1989FA;
  color: #ffffff;
}
.title{
  margin:40px 0 20px 0;
}
.deletes{
  cursor: pointer;
}
.meeting-staff{
  margin-top: 40px;
}
.el-cascader{
  width: 50%;
  margin-bottom: 40px;
}
.delete-button{
  margin-bottom: 50px;
}
.self-reserve{
  margin-top: 50px;
}
.name-list{
  min-height: 40px;
  text-align: center;
}
.name-bookers{
  display: block;
  width: 100%;
  text-align: center;
}
@media screen and (max-width:640px) {
  .el-col-6{
    width: 33.333%;
  }
}
@media screen and (max-width:374px) {
  .el-col-6{
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue